/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_App_Open_SearchInputs */

const en_nav_app_open_search = /** @type {(inputs: Nav_App_Open_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open search`)
};

const es_nav_app_open_search = /** @type {(inputs: Nav_App_Open_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir búsqueda`)
};

/**
* | output |
* | --- |
* | "Open search" |
*
* @param {Nav_App_Open_SearchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_open_search = /** @type {((inputs?: Nav_App_Open_SearchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_Open_SearchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_open_search(inputs)
	return en_nav_app_open_search(inputs)
});